<template>
    <div id="studentsReviews" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'STUDENT REVIEWS'" :subtitle="'As instructor and Coach of Voice & Stage Drama'" :description="description_EN" />                    
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'ОТЗЫВЫ СТУДЕНТОВ'" :subtitle="'Преподавателя вокала и актёрского мастерства'" :description="description_RU" />                             
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'ВІДГУКИ СТУДЕНТІВ'" :subtitle="'Викладача вокалу та майстерності актора'" :description="description_UA" />                             
        </span>
        <Testimonials :testimonials="Reviews" class="mt-5" /> 
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import Testimonials from '@/components/testimonials/Testimonials'
    import students_reviews from '@/data/students_reviews.json'

    export default {
        components: { PageTitle, Testimonials },
        data: () => ({
            language: '',
            description_RU: 'Оксана - преподаватель вокала и мастерства актера, а также режиссер детских музыкально-театральных программ (Шарлотт, Северная Каролина, США)',
            description_EN: 'Oksana is a stage drama and voice instructor of Charlotte Film School (Charlotte, NC, USA). Also she is a stage drama and voice instructor of Virtuoso School of Music and Art & Dance (Ballantyne, NC, USA)',
            description_UA: 'Оксана - викладач вокалу і майстерності актора, режисер дитячих музично-театральних програм (Шарлотт, США)',  

            Reviews: null,

        }),
        created(){
            this.getStudentsReviews()
        },
        mounted(){
            this.language = MyFunctions.getLanguage()
        },
        methods: {
            getStudentsReviews(){
                this.Reviews = students_reviews
            }
        }
    }
</script>

<style>
    #studentsReviews p {
        color: #666!important;
    }
    #studentsReviews .title {
        color: #000!important;
    }
</style>
